import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, useLocation } from 'react-router-dom';
import { logged_in as loggedIn } from 'state';

import Route from './route';

const AuthenticatedRoute = ({ children, ...rest }) => (
  <Route {...rest}>
    {loggedIn() ? children : (
      <Redirect to={{ pathname: '/login', state: { from: useLocation() } }} />
    )}
  </Route>
);

AuthenticatedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthenticatedRoute;
